<script>
import moment from "@/utils/moment";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      menu: false
    };
  },
  computed: {
    ...mapState("sendNotifications", ["time"])
  },
  methods: {
    ...mapActions("sendNotifications", ["setTime"])
  }
};
</script>

<template>
  <v-menu
    top
    offset-y
    v-model="menu"
    min-width="290px"
    origin="left bottom"
    transition="scale-transition"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        dense
        filled
        readonly
        required
        clearable
        v-on="on"
        name="time"
        data-vv-as="horário"
        v-validate="'required'"
        prepend-inner-icon="mdi-clock-outline"
        label="Selecione o horário à ser enviado"
        :value="time"
        :error="errors.has('time')"
        :error-messages="errors.first('time')"
        @input="setTime"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      format="24hr"
      color="primary"
      :value="time"
      @click:minute="menu = false"
      @input="setTime"
    ></v-time-picker>
  </v-menu>
</template>



// WEBPACK FOOTER //
// src/components/Notifications/Send/Steps/Scheduling/TimePicker.vue